import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'

const SummaryPlaceholder = styled(Pane)`
  height: ${rem(500)};
`

const ImagePlaceholder = styled(LoadingBox)`
  aspect-ratio: 3 / 2;

  ${mediaQueryUp.tablet} {
    aspect-ratio: 16 / 9;
  }
`

function ExperienceOfferPageLoadingSkeleton() {
  return (<div>
    <ImagePlaceholder />
    <SummaryPlaceholder />
  </div>

  )
}

export default React.memo(ExperienceOfferPageLoadingSkeleton)
